import { Box, Stack, Typography } from "@mui/material";
import { BankAccountDropdown } from "Components/Shared/Inputs/Form/BankAccountDropdown";
import type { BankAccountListItem } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import type { Control, FieldValues, Path } from "react-hook-form";

type BankAccountFormShape = { bankAccountPublicID?: string };

type Props<T extends FieldValues & BankAccountFormShape> = {
  control: Control<T>;
  bankAccounts: Array<BankAccountListItem>;
  onBankAccountChange?: (bankAccountPublicID: string) => void;
};

export const BankAccountSection = <
  T extends FieldValues & BankAccountFormShape,
>({
  control,
  bankAccounts,
  onBankAccountChange,
}: Props<T>) => {
  const { t } = useResource();

  return (
    <Stack gap={2}>
      <Typography
        fontSize={14}
        fontWeight={500}
        lineHeight="20px"
        color="black"
        textTransform="uppercase"
      >
        {t(Resources.Customer.Pay.BankAccount)}
      </Typography>
      <Box
        sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "common.white" } }}
      >
        <BankAccountDropdown
          control={control}
          name={"bankAccountPublicID" as Path<T>}
          accounts={bankAccounts}
          isBalanceVisible
          isPrimaryChipHidden
          onValueChange={onBankAccountChange}
        />
      </Box>
    </Stack>
  );
};
